import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Grid from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import NavItem from 'react-bootstrap/NavItem';
import { Link } from 'react-router-dom';
import Layout from '../desktop/Layout';

class ContactUs extends React.Component {
  render() {
    return (
      <Layout>
        <div className="main-view">
          <div className="bgimg">
            <div className="topleft">
              <p>New AJIO Stack</p>
            </div>
            <div className="middle">
              <h1>COMING SOON. Please have some patience</h1>
              <hr />
              <p>35 days left</p>
            </div>
            <div className="bottomleft">
              <p>React Project in new Stack. Contact us in UI LAB.</p>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

export default ContactUs;
